module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('el-form', {
    ref: "firm",
    staticClass: "gForm",
    attrs: {
      "label-position": "right",
      "rules": _vm.rules,
      "label-width": "12.5%",
      "model": _vm.firm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceName'),
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.name),
      callback: function($$v) {
        _vm.$set(_vm.firm, "name", $$v)
      },
      expression: "firm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_deviceNo'),
      "prop": "no"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.no),
      callback: function($$v) {
        _vm.$set(_vm.firm, "no", $$v)
      },
      expression: "firm.no"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_distributor'),
      "prop": "mech"
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_type'),
      "prop": "type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_select')
    },
    model: {
      value: (_vm.firm.type),
      callback: function($$v) {
        _vm.$set(_vm.firm, "type", $$v)
      },
      expression: "firm.type"
    }
  }, _vm._l((_vm.dvs), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_model'),
      "prop": "model"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_select')
    },
    model: {
      value: (_vm.firm.model),
      callback: function($$v) {
        _vm.$set(_vm.firm, "model", $$v)
      },
      expression: "firm.model"
    }
  }, _vm._l((_vm.mds), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_firm'),
      "prop": "firm"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('app_select')
    },
    model: {
      value: (_vm.firm.firm),
      callback: function($$v) {
        _vm.$set(_vm.firm, "firm", $$v)
      },
      expression: "firm.firm"
    }
  }, _vm._l((_vm.firms), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_addres'),
      "prop": "addr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.addr),
      callback: function($$v) {
        _vm.$set(_vm.firm, "addr", $$v)
      },
      expression: "firm.addr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.remark'),
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.firm.remark),
      callback: function($$v) {
        _vm.$set(_vm.firm, "remark", $$v)
      },
      expression: "firm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save('firm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_save')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b6d4a9d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nonintelligent/device/edit.vue
// module id = 1085
// module chunks = 0